import React from "react";
import { NakiNigunPremiumBadgeTemplate } from "themes/application/payment/components";

function NakiNigunPremiumBadge(props) {
    return <NakiNigunPremiumBadgeTemplate {...props} />;
}

export default NakiNigunPremiumBadge;
